import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { COUNTRY_CODES } from '../../constants';
import { NONPAY, PAY } from '../../constants/metrics';
import MetricsBox from '../MetricsBox';

export default function ReachMetrics({ country, platformTotals }) {
  const { t } = useTranslation('marketing');
  const isUS = country === COUNTRY_CODES.USA;
  const stats = isUS ? PAY : NONPAY;

  let mergedStats = stats;
  if (platformTotals) {
    mergedStats = stats.map((stat) => {
      const replacement = platformTotals.find(total => total.key === stat.key);
      let newHeader = stat.header;
      if (replacement) {
        newHeader = replacement.value;
      }

      return Object.assign({}, stat, {
        header: newHeader,
        text: isUS ? stat.text : t(`metrics.${stat.key}`, { ns: 'marketing' }),
      });
    });
  }

  return (
    <MetricsBox header={t('metrics.metricsHeader', { ns: 'marketing' })} metrics={mergedStats} />
  );
}

ReachMetrics.propTypes = {
  country: PropTypes.oneOf(Object.values(COUNTRY_CODES)),
  platformTotals: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
  })),
};

ReachMetrics.defaultProps = {
  country: COUNTRY_CODES.USA,
  platformTotals: [],
};
